// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag--3773H"};